import axios from "axios";
import { domain } from "../../Links/Links";
import { getCookie } from "../../../App";

export async function withdrawalConfirmationRequest(
  navigate,
  transactionID,
  memo,
  _status,
) {

  const data = { transaction_id: transactionID, memo: memo, status: _status};
  const response = await axios.post(domain + "/withdrawal_confirmation/", data, {
    withCredentials: true,
    headers: {
      "X-CSRFToken": getCookie("csrf_token"),
    },
  });

  if (response.data.ok == true) {
    navigate("/history");
  }
}
